export default __webpack_public_path__ + "static/serhant-logo-4999b8386f3c5a04173feaa37cd57c6b.svg";